import React from 'react'

function Header() {
  return (
    <div className="header" >
     <div className="container-fluid mt-5 p-5">
      <div className="header-title ">
        <h2>Dreamy hand made nails.</h2>
        <p>we design nails that match your daily outfit.</p>
        <p><a href="/Product" className="btn btn-light btn-card btn2 "> Products</a></p>

      </div>

     </div>
  

    </div>
    
  )
}

export default Header;